import ExhibitPreview from "./ExhibitPreview";

export default ExhibitPreview